import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import SitesList from "./SitesList";

const AllSites = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );

  const canAdd = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.manageRegistry),
    [platformPermissions]
  );

  return (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      ></Box>
      <Box sx={HeaderStyle}>
        <Typography fontWeight="medium" color="text.primary">
          All Sites
        </Typography>

        {canAdd && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenDrawer(true)}
            >
              New Site
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100vh - 132px)", overflow: "auto" }}>
        <SitesList
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          canEdit={canAdd}
        />
      </Box>
    </>
  );
};

export default AllSites;
